import styled from 'styled-components'

const Content = styled.div``

Content.defaultProps = {
}

export {
  Content
}